import React from 'react'
import { params } from '../../../../../../redux/reducers/reducer'
import WallNameTemplate from '../../../../WallName/WallNameTemplete';

const WallName = () => {

    let wallTemplates = [
        { position: [0, 0, -(params.p_d / 2 + params.leanB_p_d + 1)], rotation: [0, Math.PI, 0], slopeAngle: 60, value: 'Back Building Front' },
        { position: [(params.leanB_p_w / 2 + 1), 0, -(params.p_d / 2 + params.leanB_p_d / 2)], rotation: [0, Math.PI / 2, 0], slopeAngle: 60, value: 'Back Building Left' },
        { position: [-(params.leanB_p_w / 2 + 1), 0, -(params.p_d / 2 + params.leanB_p_d / 2)], rotation: [0, -Math.PI / 2, 0], slopeAngle: 60, value: 'Back Building Right' }
    ]

    if(params.add_storage_check_back && params.backLeanStoragePosition != 0){
        let positionX =  -params.p_d /2 - params.backLeanStoragePosition;
        let backStorage = {
             position: [0, 0, positionX], 
             rotation: [0, 0 , 0], 
             slopeAngle: 60,
             value:  'Back Building Storage Back'
            };

        wallTemplates = [...wallTemplates,backStorage]
    }
    if(params.add_storage_check_back && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back)){
        let positionX = -params.p_d /2 - parseInt(params.add_storage_back) - params.backLeanStoragePosition;
        let backStorage = {
             position: [0, 0, positionX], 
             rotation: [0, Math.PI, 0], 
             slopeAngle: 60,
             value:  'Back Building Storage Front'
            };

        wallTemplates = [...wallTemplates,backStorage]
    }

    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplate
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName